import http from '@/api/common'

export default {
  getAllCountries() {
    return http.get('countrystate/GetCountryList')
  },
  getStateProvinces(id) {
    return http.get(`countrystate/GetStateProvinceList?id=${id}`)
  },
  upsertCountry(data) {
    return http.post('countrystate/UpsertCountry', data)
  },
  upsertStateProvince(data) {
    return http.post('countrystate/UpsertStateProvince', data)
  },
  deleteStateProvince(data) {
    return http.post('countrystate/DeleteStateProvince', data)
  }
}



// WEBPACK FOOTER //
// ./src/api/endpoints/countries.js